
/**
 * Calculates and days for the bit data by
 * bitwise calculations
 *
 * @export
 * @param {Number} bitData
 */
export default function(bitData) {
    /**
     * Info about day and there
     * bitwise representation value
     */
    const DayInfo = [
        {
            value: 1,
            day: 'sunday',
            label: 'Su'
        },
        {
            value: 2,
            day: 'monday',
            label: 'Mo'
        },
        {
            value: 4,
            day: 'tuesday',
            label: 'Tu'
        },
        {
            value: 8,
            day: 'wednesday',
            label: 'W'
        },
        {
            value: 16,
            day: 'thursday',
            label: 'Th'
        },
        {
            value: 32,
            day: 'friday',
            label: 'F'
        },
        {
            value: 64,
            day: 'saturday',
            label: 'Sa'
        }
    ]
    if(DayInfo.every((currDay) =>(currDay.value & bitData) !== 0))
        return 'All Days'
    // Reduce array checking with and operator 
    return DayInfo.reduce((dayAcc, currDay) => dayAcc + ((currDay.value & bitData) !== 0 ? currDay.label + ' ' : ''), '')
    
}
